import { isNil, keys } from 'ramda';
import React from 'react';
import Icon from '~/components/Icon';
import { GetEntityActivityOverviewQuery } from '~/graphql/types';

const activitiesConfig = {
  newContacts: {
    icon: <Icon name="user-plus" inline />,
    description: 'Nieuwe contacten vandaag',
    label: 'contact(en)',
    link: '/-/contacts',
    value: 0,
  },
  openTasks: {
    icon: <Icon name="check-square" inline />,
    description: 'Open taken',
    label: 'taken',
    link: '/-/tasks',
    value: 0,
  },
};

const getActivities = (data: GetEntityActivityOverviewQuery | undefined) => {
  if (!data?.getEntityActivityOverview) return activitiesConfig;

  return keys(activitiesConfig).reduce((activities, currentActivityKey) => {
    if (!isNil(data.getEntityActivityOverview[currentActivityKey])) {
      activities[currentActivityKey] = {
        ...activitiesConfig[currentActivityKey],
        value: data.getEntityActivityOverview[currentActivityKey],
      };
    }
    return activities;
  }, {});
};

export default getActivities;
